import { CALL_API } from '../../../middleware/api'
import * as actions from '../jacktopGames';

export function getJacktopGamesToken(languageId, gameId) {
  return dispatch => dispatch({
    type: actions.GET_JACKTOP_TOKEN,
    languageId,
    gameId,
    [CALL_API]: {
      endpoint: '/api/games-tvbet/',
      method: 'get',
      types: [actions.SUCCESS_GET_JACKTOP_TOKEN, actions.FAILURE_GET_JACKTOP_TOKEN],
      credentials: true,
    }
  })
}


// WEBPACK FOOTER //
// ./js/actions/jacktopGames/creators/jacktopGames.js